export enum DATE_FORMAT {
  DATE_EN = 'yyyy-MM-dd',
  DATE_FR_NO_TIME_SEPARATE_BY_SLASH = 'dd/MM/yyyy',
}
